import { c as _c } from "react/compiler-runtime";
import { List, ListItem } from '@/comps/list';
import { cn } from '@/utils/shad';
import { getSpecialTimeKindLabel, SPECIAL_TIME_KINDS, SpecialTimeKind } from '@/comps/FilterPicker/filter-content-v2/specialTimeFilterAdapter';
type Props = {
  selectedKind: SpecialTimeKind | null;
  onSelectKind: (kind: SpecialTimeKind) => void;
};
export function FilterContentV2SpecialTimeKindDropdown(t0) {
  const $ = _c(5);
  const {
    selectedKind,
    onSelectKind
  } = t0;
  let t1;
  if ($[0] !== onSelectKind || $[1] !== selectedKind) {
    t1 = SPECIAL_TIME_KINDS.map(kind => <ListItem key={kind} className={cn("flex cursor-pointer items-center rounded-[8px] p-2 transition-colors hover:bg-neutral-800", selectedKind === kind && "bg-neutral-800")} onClick={() => onSelectKind(kind)}><span className="text-xs text-foreground">{getSpecialTimeKindLabel(kind)}</span></ListItem>);
    $[0] = onSelectKind;
    $[1] = selectedKind;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="bg-[#09090B] p-1 shadow-md"><List className="z-50 flex w-auto flex-col gap-0.5">{t1}</List></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}